import { Box, Card, Container } from '@material-ui/core';
import { SGSHelpButton } from 'components';
import styles from './Mentions.module.scss';

import React from 'react';

type Props = {};

const MentionsLegales: React.FC<Props> = () => {
    return (
        <>
            <SGSHelpButton />
            <Container>
                <Card>
                    <Box sx={{ width: '100%', height: '100%', padding: '20px', color: '#898d91' }}>
                        <h3>Mentions légales</h3>
                        <br />
                        <p>
                            <span className={styles.important}>Identification :</span>
                        </p>
                        <p>
                            Hébergeur du site : <span className={styles.colored}>AGEO</span>
                        </p>
                        <p>
                            Editeur du site : <span className={styles.colored}>AGEO</span>
                        </p>
                        <p>
                            <span className={styles.colored}>
                                AGEO
                                <br />
                                Nom commercial : SG SANTE
                            </span>
                            <br />
                            Siège social : 7 rue de Turbigo - 75001 PARIS
                            <br />
                            RCS PARIS 493 349 682
                            <br />
                            <br />
                            N° ORIAS : 15 001 350
                            <br />
                            <a href="https://www.orias.fr/welcome" target="_blank">
                                www.orias.fr
                            </a>
                        </p>
                        <p>
                            Adresse administrative 14, rue Joliot Curie - CS 30248
                            <br />
                            51010 Châlons en Champagne Cedex
                        </p>
                        <p>
                            Société de courtage en assurances sous le contrôle de l'Autorité de Contrôle Prudentiel et de Résolution -{' '}
                            <a href="https://acpr.banque-france.fr" target="_blank">
                                https://acpr.banque-france.fr
                            </a>
                            <br />
                            Garantie financière et assurance de responsabilité civile conforme au Code des assurances.
                            <br />
                            Code APE 6622Z
                        </p>
                        <p>
                            Président : Eric OZIEBALA
                            <br />
                            Directeurs généraux : Maryse OZIEBALA, Antoine GIACOMOTTO, Julie OZIEBALA, Charles-Philippe MOURGUES
                            <br />
                            Webdesign, Communication, Développement Front : Jean-François DE CUBBER
                            <br />
                            Développement Back : Support Informatique
                        </p>
                        <p>
                            Pour toute remarque relative au fonctionnement du site, contactez-nous <a href="mailto:service.reclamation@sgsante.fr">en cliquant ici</a>.
                        </p>
                        <p>
                            <span className={styles.important}>Données personnelles :</span>
                        </p>
                        <p>
                            L’assuré accepte expressément le recueil et le traitement des données concernant sa santé, nécessaires à la gestion de ses garanties. Ces données sont traitées dans le
                            respect du secret médical. Elles sont exclusivement destinées aux personnes dûment habilitées à les traiter au sein de AGEO, notamment, et selon la nature du traitement et
                            le type de données, au médecin conseil de l’assureur ou de AGEO et à son service médical. L’assuré dispose d’un droit d’accès et de rectification aux données personnelles
                            le concernant.
                        </p>
                        <p>
                            Conformément à la{' '}
                            <a href="https://www.legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000000886460" target="_blank">
                                loi 78-17 du 6 janvier 1978
                            </a>{' '}
                            modifiée relative à l'informatique, aux fichiers et aux libertés, les internautes sont informés qu'ils disposent d'un droit d'accès, de suppression ou de modification des
                            données nominatives les concernant. Pour l'exercer, veuillez-vous adresser à AGEO, 14 rue Joliot Curie - CS 30248 - 51010 Châlons en Champagne Cedex ou contactez-nous{' '}
                            <a href="mailto:service.reclamation@sgsante.fr">en cliquant ici</a>.
                        </p>
                        <p>
                            <span className={styles.important}>Droit d'auteur :</span>
                        </p>
                        <p>
                            Pour l'exercer, veuillez-vous adresser à AGEO, Service juridique, 14 rue Joliot Curie - CS 30248 - 51010 Châlons en Champagne Cedex ou contactez-nous{' '}
                            <a href="mailto:service.reclamation@sgsante.fr">en cliquant ici</a>.<br />
                            <br />
                            L'ensemble des contenus de tous types présents sur ce site Internet sont la propriété exclusive de AGEO ou des prestataires désignés par cette société, et sont protégés par
                            la législation française et/ou internationale sur les droits d'auteur.
                            <br />
                            <br />
                            La reproduction de tout ou partie de ce site sur quelque support que ce soit (y compris pour les documents téléchargeables et les représentations iconographiques et
                            photographiques), ainsi que toute utilisation du contenu du site, autre que la consultation individuelle et privée, sont formellement interdites sauf autorisation expresse
                            de AGEO.
                            <br />
                            <br />
                            Les marques citées sur ce site sont déposées par leurs propriétaires respectifs. Toute reproduction ou représentation faites sans leur accord préalable est une contrefaçon.
                            <br />
                            <br />
                            Dans le cadre de sa communication Internet, AGEO donne la permission à tout créateur/gestionnaire de site web de pointer via un lien hypertexte sur la page d'accueil de son
                            site <a href="index.html">www.sgsante.fr</a> lien profond.
                        </p>
                        <p>
                            <span className={styles.important}>Contenu du site :</span>
                        </p>
                        <br />
                        <p>
                            L'ensemble des fonctionnalités du site sont disponibles sur la page d'accueil <a href="index.html">www.sgsante.fr</a>.<br />
                            <br />
                            Malgré tous les soins apportés à la réalisation de ce site et à son actualisation régulière, des erreurs peuvent s'être glissées dans les informations présentées. Les
                            utilisateurs du site procéderont donc à toutes vérifications utiles.
                            <br />
                            <br />
                            AGEO se réserve le droit sans avertissement préalable de corriger ou de modifier le contenu de ce site à tout moment.
                        </p>
                        <p>
                            <span className={styles.important}>Confidentialité :</span>
                        </p>
                        <p>
                            En remplissant des questionnaires, vous transmettez des informations qui pourront être utilisées exclusivement par AGEO.
                            <br />
                            <br />
                            Les renseignements nominatifs demandés sont indispensables à la gestion de votre dossier. Nous vous rappelons que vous bénéficiez d’un droit d’accès et de rectification de
                            toute information vous concernant (Cf § Données personnelles).
                        </p>
                        <p>
                            <span className={styles.important}>Cookies :</span>
                        </p>
                        <p>
                            Les « cookies » sont des fichiers texte envoyés par un site à votre navigateur et qui sont stockés sur votre ordinateur. Ils servent à vous proposer des informations
                            personnalisées en permettant au serveur visité de vous identifier.
                            <br />
                            <br />
                            Vous avez la possibilité de visiter le site <a href="index.html">www.sgsante.fr</a> en désactivant cette option dans les paramètres de votre navigateur.
                        </p>
                        <p>
                            <span className={styles.important}>Service Réclamation :</span>
                        </p>
                        <p>
                            Si vous souhaitez nous faire part de toute réclamation, vous pouvez le faire :<br />
                            <br />• Soit par courrier postal :<br />
                            <br />
                            <span className={styles.colored}>
                                SG Santé
                                <br />
                                Service Réclamation
                                <br />
                                14, rue Joliot Curie - CS 30248
                                <br />
                                51010 Châlons en Champagne Cedex
                            </span>
                            <br />
                            <br />• Soit par e-mail :<br />
                            <br />
                            <a href="mailto:service.reclamation@sgsante.fr">service.reclamation@sgsante.fr</a>
                        </p>
                        <p>
                            <span className={styles.important}>Notre Médiateur :</span>
                        </p>
                        <p>
                            Après saisie de notre service réclamation et de réponse non satisfaisante vous avez la possibilité de saisir notre médiateur (article L 152-2 du code de la consommation) :
                            <br />
                            <br />• Soit par courrier postal :<br />
                            <br />
                            <span className={styles.important}>
                                La Médiation de l'assurance
                                <br />
                                TSA 50110
                                <br />
                                75441 Paris Cedex 09
                            </span>
                            <br />
                            <br />• Soit par e-mail :<br />
                            <br />
                            <a href="mailto:le.mediateur@mediation-assurance.org">le.mediateur@mediation-assurance.org</a>
                            <br />
                            <br />
                            <a href="http://www.mediation-assurance.org/" target="_blank">
                                www.mediation-assurance.org
                            </a>
                            <br />
                            <br />
                            &nbsp;
                        </p>
                    </Box>
                </Card>
            </Container>
        </>
    );
};

export default MentionsLegales;
